import { blueGrey } from '@material-ui/core/colors'

export const PRIMARY_COLOR = '#2979FF'
export const PRIMARY_LIGHTER_COLOR = '#BED6FF'
export const PRIMARY_DARKER_COLOR = '#3172C4'
export const TEXT_PRIMARY_COLOR = '#212121'
export const TEXT_SECONDARY_COLOR = '#494D50'
export const TEXT_TERTIARY_COLOR = '#878D91'
export const SUCCESS_COLOR = '#04AE3D'
export const SUCCESS_LIGHTER_COLOR = '#9DD7B0'
export const ERROR_COLOR = '#D53939'
export const ERROR_LIGHTER_COLOR = '#EEB0B0'
export const WARNING_COLOR = '#FFAB00'
export const NOTICE_COLOR = '#8957e5'
export const SECONDARY_COLOR = '#90A4AE'
export const SECONDARY_LIGHT_COLOR = '#C1CCD2'
export const SECONDARY_LIGHTER_COLOR = '#CFD8DC'
export const TERTIARY_COLOR = '#D6E5F5'
export const TERTIARY_LIGHT_COLOR = '#DEEAF7'
export const TERTIARY_LIGHTER_COLOR = '#EAF2FA'
export const DISABLED_COLOR = '#B8B8B8'
export const BACKGROUND_COLOR = '#F3F7FC'
export const BACKGROUND_COLOR_ACTIVE = 'rgba(51, 67, 76, 0.05)'
export const PAPER_COLOR = '#FFFFFF'
export const PAPER_ACTIVE_COLOR = '#F8FAFB'
export const PAPER_FRAME_COLOR = '#F5F9FD'
export const SHEETGO_SYMBOL_GREEN_COLOR = '#00CC3E'

export const StateColor = {
    PRIMARY: PRIMARY_COLOR,
    SUCCESS: SUCCESS_COLOR,
    ERROR: ERROR_COLOR,
    WARNING: WARNING_COLOR,
    NOTICE: NOTICE_COLOR,
    DISABLED: DISABLED_COLOR
}

export const TextColor = {
    PRIMARY: TEXT_PRIMARY_COLOR,
    SECONDARY: TEXT_SECONDARY_COLOR,
    TERTIARY: TEXT_TERTIARY_COLOR
}

export const PrimaryColor = {
    MAIN: PRIMARY_COLOR,
    LIGHT: null,
    LIGHTER: PRIMARY_LIGHTER_COLOR,
    DARK: null,
    DARKER: PRIMARY_DARKER_COLOR
}

export const SecondaryColor = {
    MAIN: SECONDARY_COLOR,
    LIGHT: SECONDARY_LIGHT_COLOR,
    LIGHTER: SECONDARY_LIGHTER_COLOR
}

export const TertiaryColor = {
    MAIN: TERTIARY_COLOR,
    LIGHT: TERTIARY_LIGHT_COLOR,
    LIGHTER: TERTIARY_LIGHTER_COLOR
}

export const SuccessColor = {
    MAIN: SUCCESS_COLOR,
    LIGHTER: SUCCESS_LIGHTER_COLOR
}

export const ErrorColor = {
    MAIN: ERROR_COLOR,
    LIGHTER: ERROR_LIGHTER_COLOR
}

export const ResourceColor = {
    FORM: '#ff662e'
}

export const PaperColor = {
    MAIN: PAPER_COLOR,
    ACTIVE: PAPER_ACTIVE_COLOR,
    FRAME: PAPER_FRAME_COLOR
}

export const PremiumPaperColor = {
    Active: {
        BACKGROUND_COLOR: 'rgba(206, 137, 71, 0.20)',
        BORDER_COLOR: 'rgba(206, 137, 71, 0.25)'
    },
    Hover: {
        BACKGROUND_COLOR: 'rgba(206, 137, 71, 0.15)',
        BORDER_COLOR: 'rgba(206, 137, 71, 0.25)'
    },
    BORDER_COLOR: 'rgba(206, 137, 71, 0.25)',
    MAIN: 'rgba(206, 137, 71, 0.05)'
}

export const BackgroundColor = {
    MAIN: BACKGROUND_COLOR,
    ACTIVE: BACKGROUND_COLOR_ACTIVE
}

export const PAPER_SHADOW = '4px 6px 8px 0px #00000003'
export const PAPER_SHADOW_ACTIVE = '4px 6px 22px 0px #00000014'

export const PaperShadow = {
    MAIN: PAPER_SHADOW,
    ACTIVE: PAPER_SHADOW_ACTIVE
}

export const AlertColor = {
    Light: {
        Basic: {
            COLOR: '#696969',
            BORDER_COLOR: '#e4eaec',
            BACKGROUND_COLOR: '#edf1f2'
        },
        Success: {
            COLOR: '#1e4620',
            BACKGROUND_COLOR: '#edf7ed'
        },
        Error: {
            COLOR: '#611a15',
            BACKGROUND_COLOR: '#fdecea'
        },
        Info: {
            COLOR: '#0d3c61',
            BACKGROUND_COLOR: '#e8f4fd'
        },
        Warning: {
            COLOR: '#664400',
            BACKGROUND_COLOR: '#fff6e5'
        },
        Attention: {
            COLOR: '#4a301c',
            BACKGROUND_COLOR: '#f7e9de'
        },
        Notice: {
            COLOR: '#4a301c',
            BORDER_COLOR: '#1e262929',
            BACKGROUND_COLOR: '#f7e9de'
        }
    },
    Dark: {
        Basic: {
            COLOR: blueGrey[200],
            BORDER_COLOR: blueGrey[800],
            BACKGROUND_COLOR: blueGrey[900]
        },
        Success: {
            COLOR: '#b7dfb9',
            BACKGROUND_COLOR: '#071107'
        },
        Error: {
            COLOR: '#fab3ae',
            BACKGROUND_COLOR: '#180605'
        },
        Info: {
            COLOR: '#a6d5fa',
            BACKGROUND_COLOR: '#030e18'
        },
        Warning: {
            COLOR: '#ffd599',
            BACKGROUND_COLOR: '#190f00'
        },
        Attention: {
            COLOR: '#f7e9de',
            BACKGROUND_COLOR: '#25180e' // Color from light, but with lightning decreased to 10%
        }
    }
}

export const ENTERING_SCREEN_TRANSITION_DURATION = 225
export const LEAVING_SCREEN_TRANSITION_DURATION = 195
